import React, { FC } from 'react';
import { Control, useWatch } from 'react-hook-form';

import { formatCurrencyValue } from '@eika/currency-input';

import { useTranslation } from '../../translations';
import { GjeldFormData } from './gjeld';

interface Props {
    index: number;
    control: Control<GjeldFormData>;
}

const GjeldAnnenBank: FC<Props> = ({ index, control }) => {
    const { gjeld: bankgjeld } = useTranslation();
    const value = useWatch({ name: 'gjeld', control });

    return (
        <div className="info-box-white row-gap margin-bottom-small">
            <span className="title">{`${value?.[index]?.laangiver}`}</span>
            <span>{`${bankgjeld.infoTypeLaan}: ${bankgjeld.selectValueBoliglaan}`}</span>
            <span>{`${bankgjeld.infoDagensSaldo}: ${formatCurrencyValue(value?.[index]?.restgjeld || 0)} kr`}</span>
            <span>{`${bankgjeld.infoInnfris}`}</span>
        </div>
    );
};

export default GjeldAnnenBank;
